<template>
  <!-- 课消统计 -->
  <div class="sales-statistics">
    <el-form class="select" label-width="130px">
      <el-form-item label="日期:">
        <el-date-picker v-model="ownerDate" value-format="yyyy-MM" type="month" placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="教师姓名:">
        <el-input placeholder="请选择教师姓名" v-model="teacherName" clearable></el-input>
      </el-form-item>
      <el-form-item label="当月课消:">
        <el-input placeholder="请输入当月课消" v-model="classHour" clearable></el-input>
      </el-form-item>
      <el-form-item label="总课消:">
        <el-input placeholder="请输入总课消" v-model="classSumFee" clearable></el-input>
      </el-form-item>
      <el-form-item label="课时数:">
        <el-input placeholder="请输入课时数" v-model="classNum" clearable></el-input>
      </el-form-item>
      <el-form-item label="平均课时费:">
        <el-input placeholder="请输入平均课时费" v-model="classMeanFee" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="clear" class="btns" size="small" icon="el-icon-close">清除</el-button>
        <el-button type="primary" @click="searchBtn" size="small" class="btns" icon="el-icon-search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="goChart" size="small" class="btns" icon="el-icon-postcard">课消统计图</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="count" icon="el-icon-thumb" size="small" class="btns">一键计算</el-button>
      </el-form-item>
    </el-form>
    <!-- table表格 -->
    <el-table :header-cell-style="{
      background: '#fafafa',
    }" :data="dataList" border>
      <el-table-column prop="ownerDate" label="日期">
      </el-table-column>
      <el-table-column prop="teacherName" label="教师姓名">
      </el-table-column>
      <el-table-column prop="classNum" label="课时数">
      </el-table-column>
      <el-table-column prop="classHour" label="当月课消">
      </el-table-column>
      <el-table-column prop="classMeanFee" label="当月平均课时费">
      </el-table-column>
      <el-table-column prop="classSumNum" label="总课时数">
      </el-table-column>
      <el-table-column prop="classSumFee" label="总课消">
      </el-table-column>
      <el-table-column prop="classEntiretyMeanFee" label="整体平均课时费">
      </el-table-column>

      <el-table-column header-align="center" label="操作" width="150px">
        <template slot-scope="scope">
          <el-button type="text" @click="details(scope.row.id)">详情</el-button>
          <el-button type="text" @click="dele(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="requestParameters.pageNum" :page-size="requestParameters.pageSize"
      layout="prev, pager, next,sizes, jumper" :total="total">
    </el-pagination>
    <!-- 详情 -->
    <el-dialog title='课时统计详情' :visible.sync="dialogFormVisible">
      <el-form label-width="150px">
        <el-form-item label="日期:" style="text-align: left;">
          <span>{{ detailsObj.ownerDate }}</span>
        </el-form-item>
        <el-form-item label="教师姓名:" style="text-align: left;">
          <span>{{ detailsObj.teacherName }}</span>
        </el-form-item>
        <el-form-item label="课时数:" style="width: 100%; text-align: left;">
          <span>{{ detailsObj.classNum }}</span>
        </el-form-item>
        <el-form-item label="当月课消:" style="width: 100%; text-align: left;">
          <span>{{ detailsObj.classHour }}</span>
        </el-form-item>
        <el-form-item label="当月平均课时费:" style="width: 100%; text-align: left;">
          <span>{{ detailsObj.classSumFee }}</span>
        </el-form-item>
        <el-form-item label="总课时数:" style="width: 100%; text-align: left;">
          <span>{{ detailsObj.classSumNum }}</span>
        </el-form-item>
        <el-form-item label="总课消:" style="width: 100%; text-align: left;">
          <span>{{ detailsObj.classSumFee }}</span>
        </el-form-item>
        <el-form-item label="整体平均课时费:" style="width: 100%; text-align: left;">
          <span>{{ detailsObj.classEntiretyMeanFee }}</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../../config/api";
export default {
  data () {
    return {
      dialogFormVisible: false,
      total: 0,//总条数
      requestParameters: {
        pageSize: 10, //每页多少条
        pageNum: 1, //当前显示页码
      },
      ownerDate: '',//日期
      teacherName: "",//教师姓名
      classHour: "",//当月课消
      classSumFee: "",//总课消
      classNum: "",//课时数
      classMeanFee: "",//当月平均课时费
      dataList: [],
      detailsObj: {
        ownerDate: '',//日期
        teacherName: '',//教师姓名
        classNum: '',//课时数
        classHour: '',//当月课消
        classMeanFee: '',//当月平均课时费
        classNum: '',//首次课数
        classSumNum: '',//总课时数
        classSumFee: '',//总课消
        classEntiretyMeanFee: '',//整体平均课时费
      }
    }
  },
  created () {
    // this.getTime()
    this.getListData()
  },

  methods: {
    // getTime () {
    //   // 获取当前时间
    //   const today = new Date();
    //   // 获取当前时间(today)的年份
    //   const year = today.getFullYear();
    //   // 获取月份
    //   const month = String(today.getMonth() + 1).padStart(2, '0');
    //   this.ownerDate = `${year}-${month}`; //当前日期
    // },
    //一键计算
    count () {
      axios
        .get(`${apiBaseUrl}/classSales/getClassSalesByTime?time=${this.ownerDate}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success(res.data.message)
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch(error => {
          console.error(error);
        });
      let obj = {
        pageNum: this.requestParameters.pageNum,
        pageSize: this.requestParameters.pageSize,
        ownerDate: this.ownerDate
      }
      axios
        .post(`${apiBaseUrl}/classSales/getList`, obj,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(response => {
          if (response.data.data.code == 200) {
            this.total = response.data.data.data.total
            this.dataList = response.data.data.data.records
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    //清除
    clear () {
      this.ownerDate = '',
        this.teacherName = '',
        this.classHour = '',
        this.classSumFee = '',
        this.classNum = '',
        this.classMeanFee = '',
        this.getListData()
    },
    //搜索
    searchBtn () {
      let data = {
        pageNum: this.requestParameters.pageNum,
        pageSize: this.requestParameters.pageSize,
        ownerDate: this.ownerDate,
        teacherName: this.teacherName,
        classHour: this.classHour,
        classSumFee: this.classSumFee,
        classNum: this.classNum,
        classMeanFee: this.classMeanFee
      }
      axios
        .post(`${apiBaseUrl}/classSales/getList`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(response => {
          if (response.data.data.code == 200) {
            this.total = response.data.data.data.total
            this.dataList = response.data.data.data.records
            this.$message.success(response.data.message)
          } else {
            this.$message.error(response.data.message)
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    //跳转
    goChart () {
      this.$router.push({
        // name: "CourseStatistics",
        path: "/courseStatistics",
        query: {
          time: this.ownerDate
        }
      })
    },
    //获取table表数据
    getListData () {
      axios
        .post(`${apiBaseUrl}/classSales/getList`, this.requestParameters,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(response => {
          if (response.data.data.code == 200) {
            this.total = response.data.data.data.total
            this.dataList = response.data.data.data.records
          }

        })
        .catch(error => {
          console.error(error);
        });
    },
    handleSizeChange (pageSize) {
      this.requestParameters.pageSize = pageSize;
      if (this.requestParameters.page === 1) {

      }
      let obj = {
        pageNum: this.requestParameters.pageNum,
        pageSize: this.requestParameters.pageSize,
        ownerDate: this.ownerDate
      }
      axios
        .post(`${apiBaseUrl}/classSales/getList`, obj,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(response => {
          if (response.data.data.code == 200) {
            this.total = response.data.data.data.total
            this.dataList = response.data.data.data.records
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    // 进入某一页
    handleCurrentChange (newPage) {
      this.requestParameters.pageNum = newPage;
      let obj = {
        pageNum: this.requestParameters.pageNum,
        pageSize: this.requestParameters.pageSize,
        ownerDate: this.ownerDate
      }
      axios
        .post(`${apiBaseUrl}/classSales/getList`, obj,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(response => {
          if (response.data.data.code == 200) {
            this.total = response.data.data.data.total
            this.dataList = response.data.data.data.records
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    //详情
    details (id) {
      this.dialogFormVisible = true
      axios
        .get(`${apiBaseUrl}/classSales/getDetail?id=${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(response => {
          if (response.data.code == 200) {
            this.$message.success(response.data.message)
            this.detailsObj = response.data.data
          } else {
            this.$message.error(response.data.message)
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    dele (id) {
      axios
        .get(`${apiBaseUrl}/classSales/delete?id=${id},{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }`) // 请替换为你的API URL
        .then(response => {
          if (response.data.code == 200) {
            this.$message.success('删除成功')
            this.getListData()
          } else {
            this.$message.error('删除失败')
          }
        })
        .catch(error => {
          console.error(error);
        });
    }
  }
}
</script>

<style scoped>
.select {
  display: flex;
  flex-wrap: wrap;
}

@media screen and (max-width: 750px) {
  .sales-statistics {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */
  #aa>>>.sales-statistics {
    width: 70% !important;
  }
}

.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/manager/components/salesStatistics.vue